import React from "react";
import { LuBookMarked } from "react-icons/lu";
import { IoNutrition } from "react-icons/io5";
import { FaPersonRunning } from "react-icons/fa6";
import { IoBagAdd } from "react-icons/io5";
import { NavLink } from "react-router-dom";
import HeadingText from "./atoms/HeadingText";
import useTranslate from "../hooks/useTranslate";

function ServicesNav() {
  const description = useTranslate("workwithMnPage.servicesNav.description");
  const nav = useTranslate("workwithMnPage.servicesNav.navList");
  const navIconMap = {
    ioNutrition: IoNutrition,
    luBookMarked: LuBookMarked,
    faPersonRunning: FaPersonRunning,
    ioBagAdd: IoBagAdd,
  };
  return (
    <section className=" bg-primary-50 pt-12">
      <div className="max-w-6xl mx-auto px-4">
        <HeadingText variant="h3" classes="!text-xl text-center animate-fadeIn">
          {description}
        </HeadingText>
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-center items-center">
          {nav.map((item) => {
            const NavIcon = navIconMap[item.icon];
            return (
              <NavLink
                exact
                className={({ isActive }) =>
                  `p-8 basis-1/4 flex flex-col justify-center items-center hover:bg-white transition-all duration-300 ${
                    isActive
                      ? "bg-white border-b-2 border-t-0 border-x-0 border-primary border-solid"
                      : ""
                  }`
                }
                to={item.link}
              >
                <NavIcon className="text-4xl text-primary" />
                <HeadingText
                  variant="h2"
                  classes="!text-xl text-center animate-fadeIn pt-4 !mb-0"
                >
                  {item.heading}
                </HeadingText>
              </NavLink>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ServicesNav;
